(ns nosco.ui.checkbox
  (:require
   ["react" :as React]
   [hx.hooks :refer [useLayoutEffect]]
   [hx.react :refer [defnc]]
   [hx.react :as hx]
   [nosco.colors :as colors]
   [nosco.hooks]
   [nosco.icons2 :as icons2]
   [nosco.react]
   [nosco.ui.text :as text]))

(defnc Checkbox
  "You can either pass default-indeterminate for an uncontrolled component
  OR inderminate & checked for a controlled one."
  [{:keys [variant faux-checkbox? default-indeterminate indeterminate error checked on-shift-change on-change] :as props
    :or {variant :default}}]
  {:pre [(#{:small :default :large} variant)]}
  (let [input-ref (React/useRef)
        passdown-props (dissoc props :on-change :on-shift-change :faux-checkbox?)]
    (if default-indeterminate
      ;; this looks to violate the rules of hooks since we have hooks
      ;; in a conditional, but otherwise react complains about switching
      ;; a component from uncontrolled to controlled
      (useLayoutEffect
       (fn []
         (set! (.-current.indeterminate input-ref) default-indeterminate)
         (fn []))
       [])
      (useLayoutEffect
       (fn []
         (set! (.-current.indeterminate input-ref) indeterminate)
         (fn []))
       [indeterminate]))
    [:div {:class ["nosco-checkbox"
                   (when (= variant :small) "nosco-checkbox--variant-small")
                   (when (= variant :large) "nosco-checkbox--variant-large")
                   (when faux-checkbox? "nosco-checkbox--faux-checkbox")]}
     [:input (nosco.react/merge-props
              {:type "checkbox"
               :ref input-ref
               :class ["nosco-checkbox__input"
                       (when error "nosco-checkbox__input--error")
                       (when faux-checkbox? "nosco-checkbox__input--faux-checkbox")]
               :on-change (fn [ev] (cond (and on-shift-change (.. ev -nativeEvent -shiftKey)) (on-shift-change ev)
                                         on-change (on-change ev)))}
              (cond-> passdown-props
                (and default-indeterminate (not checked))
                (dissoc :checked)
                :always
                (dissoc :default-indeterminate :indeterminate :error)))]
     ;; The design system is a bit peculiar here, all 3 size variants
     ;; use the same icon sizes - a small Done icon and a large Dash icon scaled down to 16px
     [icons2/Icon {:icon icons2/Dash-large
                   :color colors/white
                   :class "nosco-checkbox__indeterminate"
                   :icon-style {:width (if (= variant :small) 12 16)
                                :height (if (= variant :small) 12 16)}}]
     [icons2/Icon (cond-> {:icon icons2/Done-small
                           :color colors/white
                           :class "nosco-checkbox__check"}
                    (= variant :small) (assoc :icon-style {:width 12
                                                           :height 12}))]]))

(defnc CheckboxWithLabel [{:keys [label id name container-props wrap-label? variant text-color-class]
                           :as props
                           :or {variant :default
                                text-color-class (if (:disabled props)
                                                   "text-neutral-300"
                                                   "text-neutral-900")}}]
  {:pre [(#{:small :default :large} variant)]}
  (let [id (nosco.hooks/use-id id name)]
    [:label (nosco.react/merge-props
             {:class ["nosco-checkbox-with-label"
                      (when wrap-label? "wrap-label")]}
             container-props)
     [Checkbox (nosco.react/merge-props
                {:id id
                 :data-form-field-interactive true}
                (dissoc props :label :id :container-props :wrap-label? :text-color-class))]
     [:span {:style {:display "inline-block"
                     ;;padding as opposed to margin so pointer events don't pass through
                     :padding-left (case variant
                                     :small "4px"
                                     :default "8px"
                                     :large "8px")}}]
     [text/Text {:variant (case variant
                            :small text/Body-Sm-Regular
                            :default text/Body-Md-Regular
                            :large text/Body-Lg-Regular)
                 :class ["nosco-checkbox-with-label__label-text" text-color-class]}
      label]]))

(defnc ToggleSwitch [{:keys [label text-variant size] :as props
                      :or {text-variant text/Label-Field-Label}}]
  (let [input (hx/f [:input (nosco.react/merge-props
                             {:type "checkbox"}
                             (dissoc props :label :text-variant))])]
    [:div {:class ["nosco-checkbox-toggle"
                   (when (= size :small)
                     "nosco-checkbox-toggle--size-default")]

           :on-click (fn [e]
                       (.stopPropagation e))}
     (if-not label
       input
       [text/Text {:variant text-variant
                   :el :label}
        label
        input])]))
